(() => {
  const readGap = (element) => {
    const styles = getComputedStyle(element);
    return Number.parseFloat(styles.columnGap || styles.gap) || 0;
  };

  document.querySelectorAll(".reviews-marquee").forEach((marquee) => {
    const track = marquee.querySelector(".reviews-marquee__track");
    const sets = [...marquee.querySelectorAll(".reviews-marquee__set")];
    const firstSet = sets[0];
    const secondSet = sets[1];
    if (!track || !firstSet || !secondSet || marquee.dataset.marqueeReady === "true") return;

    marquee.dataset.marqueeReady = "true";
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    const firstTemplates = [...firstSet.children].map((card) => card.cloneNode(true));
    const secondTemplates = [...secondSet.children].map((card) => card.cloneNode(true));
    let x = 0;
    let speed = 56;
    let targetSpeed = 56;
    let lastTime = 0;
    let loopWidth = 0;
    let frame = 0;
    let resizeFrame = 0;

    const removeGeneratedCards = () => {
      track.querySelectorAll("[data-marquee-generated]").forEach((card) => card.remove());
    };

    const appendTemplateBatch = () => {
      firstTemplates.forEach((template) => {
        const card = template.cloneNode(true);
        card.dataset.marqueeGenerated = "true";
        card.setAttribute("aria-hidden", "true");
        firstSet.appendChild(card);
      });
      secondTemplates.forEach((template) => {
        const card = template.cloneNode(true);
        card.dataset.marqueeGenerated = "true";
        card.setAttribute("aria-hidden", "true");
        secondSet.appendChild(card);
      });
    };

    const ensureViewportCoverage = () => {
      removeGeneratedCards();
      const minimumWidth = marquee.getBoundingClientRect().width * 1.25;
      let additions = 0;
      while (firstSet.getBoundingClientRect().width < minimumWidth && additions < 5) {
        appendTemplateBatch();
        additions += 1;
      }
    };

    const measure = () => {
      ensureViewportCoverage();
      loopWidth = firstSet.getBoundingClientRect().width + readGap(track);
      if (loopWidth > 0) {
        x = -(Math.abs(x) % loopWidth);
        track.style.transform = `translate3d(${x.toFixed(3)}px, 0, 0)`;
      }
    };

    const scheduleMeasure = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(measure);
    };

    const tick = (time) => {
      if (!lastTime) lastTime = time;
      const delta = Math.min(0.05, (time - lastTime) / 1000);
      lastTime = time;

      if (loopWidth <= 0) measure();
      speed += (targetSpeed - speed) * 0.08;
      x -= speed * delta;
      while (loopWidth > 0 && x <= -loopWidth) x += loopWidth;
      while (loopWidth > 0 && x > 0) x -= loopWidth;
      track.style.transform = `translate3d(${x.toFixed(3)}px, 0, 0)`;
      frame = requestAnimationFrame(tick);
    };

    const start = () => {
      cancelAnimationFrame(frame);
      measure();
      lastTime = 0;
      if (reduceMotion.matches) {
        track.style.transform = "none";
        return;
      }
      frame = requestAnimationFrame(tick);
    };

    marquee.addEventListener("mouseenter", () => { targetSpeed = 24; });
    marquee.addEventListener("mouseleave", () => { targetSpeed = 56; });
    window.addEventListener("resize", scheduleMeasure);
    document.addEventListener("visibilitychange", () => { lastTime = 0; });
    reduceMotion.addEventListener("change", start);
    if (window.ResizeObserver) new ResizeObserver(scheduleMeasure).observe(marquee);
    document.fonts?.ready.then(scheduleMeasure).catch(() => {});
    window.addEventListener("load", scheduleMeasure, { once: true });
    start();
  });
})();
